import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        currentRowId: null,
        page: {
            total: 0,
            records: []
        },
        pageSearch: {
            current: 1,
            size: 10,
            search: {
                like_code: null,
                like_name: null,
                like_description: null,
                status: true,
            }
        }
    },
    getters: {
        ['RoleListGetCurrentRowId'](state) {
            return state.currentRowId;
        },
        ["RoleListGetPageSearch"](state) {
            return state.pageSearch;
        },
        ["RoleListGetPageCurrent"](state) {
            return state.pageSearch.current;
        },
        ["RoleListGetPageSize"](state) {
            return state.pageSearch.size;
        },
        ["RoleListGetPageTotal"](state) {
            return state.page.total;
        },
        ["RoleListGetPageSearchSearch"](state) {
            return state.pageSearch.search;
        }
    },
    mutations: {
        ['RoleListSetCurrentRowId'](state, currentRowId) {
            state.currentRowId = currentRowId;
        },
        ['RoleListSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['RoleListSetPage'](state, page) {
            state.page = page;
        },
        ['RoleListSetPageSearch'](state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        ['RoleListSetPageSearchSearch'](state, pageSearchSearch) {
            state.pageSearch.search = pageSearchSearch;
        },
        ['RoleListSetPageCurrent'](state, current) {
            state.pageSearch.current = current;
        },
        ['RoleListSetPageSize'](state, size) {
            state.pageSearch.size = size;
        }
    },
    actions: {
        async queryByPage({commit}, params) {
            commit("RoleListSetLoading", true);
            let res = await OrganizationServer.role.page(params);
            if (res.data.code == null || res.data.code === '200') {
                res.data.data.records.forEach(r => {
                    if (r.description === null) {
                        r.description = '-';
                    }
                });
                if (res.data.data.records.length > 0) {
                    console.log("currentRowId", res.data.data.records[0].id);
                    commit('RoleListSetCurrentRowId', res.data.data.records[0].id);
                }
                commit('RoleListSetPage', res.data.data);
            }
            commit("RoleListSetLoading", false);
            return Promise.resolve();
        }
    }
}